import { defineModule } from '../types.js';
export default defineModule({
    id: 'classement',
    nom: 'Classement des écritures',
    description: 'Classe chaque écriture Zoho vers un sous-poste : règles, puis Jev, puis arbitrage. Désactivé, le budget revient au rattachement historique.',
    famille: 'exercice',
    dependances: ['exercice'],
    activableParDefaut: true,
    desactivable: true,
    routesApi: ['/api/classement'],
    droits: {
        'classement.consulter': { description: 'Voir les classements, les règles et les sous-postes', niveau: 'lecture' },
        'classement.arbitrer': {
            description: 'Arbitrer, modifier les règles et les sous-postes, relancer le classement',
            niveau: 'administration',
        },
    },
    navigation: [
        { cle: 'arbitrage', libelle: 'À arbitrer', picto: '◧', groupe: 'Exercice en cours', ordre: 15, droit: 'classement.consulter' },
        { cle: 'regles', libelle: 'Règles de classement', picto: '⋮', groupe: 'Administration', ordre: 96, droit: 'classement.consulter' },
        { cle: 'sous-postes', libelle: 'Sous-postes', picto: '⊟', groupe: 'Administration', ordre: 97, droit: 'classement.consulter' },
    ],
    reglages: {
        jev_actif: {
            type: 'booleen',
            libelle: 'Classer avec Jev',
            defaut: true,
            aide: 'Sans clé OpenRouter sur le serveur, Jev reste inactif quel que soit ce réglage.',
        },
        seuil_confiance: { type: 'nombre', libelle: 'Seuil de confiance', defaut: 75, min: 0, max: 100, unite: '%' },
        plafond_appels_jour: { type: 'nombre', libelle: 'Plafond d’appels à Jev par jour', defaut: 500, min: 0, max: 10000 },
        // Liste fermée : un texte libre permettrait d'orienter les données bancaires vers un autre modèle.
        modele: {
            type: 'choix',
            libelle: 'Modèle Jev',
            defaut: '~typesafe/jev-latest',
            options: { '~typesafe/jev-latest': 'Jev — dernière version' },
        },
        masquer_noms: {
            type: 'booleen',
            libelle: 'Masquer les noms des salariés',
            defaut: true,
            aide: 'Les noms connus des salariés sont remplacés par « [salarié] » avant tout envoi à Jev.',
        },
    },
});
//# sourceMappingURL=classement.js.map